import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `ISaasIntegration` is a concrete implementation of `AbstractIntegration`
 * for integration with ISaas.
 */
export default class IsaasIntegration extends AbstractIntegration {
	getName() {
		return this._subclassResponsibility();
	}

	isBeta() {
		return true;
	}

	hasInvoiceSupport() {
		return true;
	}

	canBeDisconnected() {
		return true;
	}

	isIsaasIntegration() {
		return true;
	}
}
